/* ======================================================
   NobleOak — questions captured during the presentation.
   `short` is the label used in the summary and the email.
====================================================== */

const questions = [
  {
    id: 'financeStage',
    short: 'Finance team stage',
    question: 'Where is the finance team today?',
    options: ['Foundational', 'Scaling', 'Systemised', 'Insight-led'],
  },
  {
    id: 'notGaps',
    short: 'Ruled out as pain points',
    question: 'Which of our guesses are not a pain point?',
    multi: true,
    options: ["Close lands after BD4", "Excel holds the close together", "Manual extracts from the ledger", "APRA returns built by hand", "Partner data arrives in different shapes", "Premium & reinsurance recs are manual", "Actuarial–finance hand-offs", "Underlying vs statutory bridges", "Board pack takes days", "Knowledge sits with a few people"],
  },
  {
    id: 'ledger',
    short: 'Accounting system',
    question: 'Which accounting system (general ledger) do you use?',
    options: ['Workday', 'NetSuite', 'MYOB', 'Xero', 'SAP', 'Oracle', 'Microsoft Dynamics 365', 'TechnologyOne', 'Sage Intacct', 'Other'],
  },
  {
    id: 'approach',
    short: 'Tooling approach',
    question: 'How would you like to build the integration layer?',
    options: ['Recommended third-party tools', 'Build internal tools with your team', 'A mix — advise us'],
  },
  {
    id: 'reporting',
    short: 'Reporting & planning tools',
    question: 'Which reporting and planning tools does the team rely on?',
    multi: true,
    options: ['Excel', 'Power BI', 'Tableau', 'Workday Adaptive Planning', 'Anaplan', 'Other'],
  },
  {
    id: 'policyData',
    short: 'Policy & premium data source',
    question: 'Where does policy and premium data come from?',
    multi: true,
    options: ['Policy admin system', 'Data warehouse', 'Partner / reinsurer files', 'Manual extracts'],
  },
  {
    id: 'workspace',
    short: 'Workplace environment',
    question: 'Which workplace environment does NobleOak run on?',
    options: ['Microsoft 365', 'Google Workspace', 'Both', 'Other'],
  },
  {
    id: 'aiTools',
    short: 'Approved AI tools',
    question: 'Which AI tools are currently approved for staff?',
    multi: true,
    options: ['Claude', 'ChatGPT / OpenAI', 'Microsoft Copilot', 'Google Gemini', 'OpenRouter', 'None approved yet', 'Other'],
  },
  {
    id: 'agentHosting',
    short: 'Preferred AI agent setup',
    question: 'Where would AI agents for finance need to run?',
    options: ['Inside Microsoft 365 / Claude Enterprise', 'In our cloud, in Australia', 'Self-hosted, on our infrastructure', 'Not sure — advise us'],
  },
  {
    id: 'dataTeam',
    short: 'Data team',
    question: 'Who looks after finance data today?',
    options: ['Dedicated data team', 'Analysts within finance', 'IT, as needed', 'No dedicated resource'],
  },
  {
    id: 'closeDay',
    short: 'Current month-end close',
    question: 'When does month-end close finish today?',
    options: ['Day 1–5', 'Day 6–10', 'Day 11–15', 'Day 16+'],
  },
  {
    id: 'teamSize',
    short: 'Finance team size',
    question: 'How large is the finance team?',
    options: ['1–5', '6–10', '11–20', '21+'],
  },
  {
    id: 'training',
    short: 'Preferred training formats',
    question: 'How does your team learn best?',
    multi: true,
    options: ['On-site working sessions', 'Hands-on support on live work', 'Short recorded walkthroughs', 'Written playbooks', 'Weekly office hours'],
  },
  {
    id: 'location',
    short: 'Ways of working',
    question: 'Where should we work with the team?',
    options: ['On site in Sydney', 'Hybrid', 'Remote'],
  },
  {
    id: 'start',
    short: 'Preferred diagnostic start',
    question: 'When would you like the diagnostic to start?',
    options: ['November 2026', 'Early December 2026', 'January 2027', 'February 2027 or later'],
  },
];

export default questions;
